module.exports = __webpack_public_path__ + "img/trip-hour-idle.e25b9daa.svg";